<div [@scaleIn] *ngIf="visible" class="dialog">

    <div class="card header shadow lift lift-sm d-flex justify-content-center">
        <h4 style="color: black;">Filter by</h4>
    </div>
    <div class="row buttons-row">
        <div class="col">
            <button type="button" (click)="clear()" class="btn btn-primary filter-btn">CLEAR</button>
        </div>
        <div class="col">
            <button type="button" (click)="onApplyFilters()" class="btn btn-primary filter-btn">APPLY</button>
        </div>
    </div>

    <div class="container">

        <div class="row ">
            <div class="card sidebar-card">
                <p class="ml"><b>Categories</b></p>
                <div class="form-check" *ngFor="let category of categories">
                    <input class="form-check-input" [(ngModel)]="category.isSelected" (change)="onChecked($event)" type="checkbox" value={{category.value}} id="defaultCheck1">
                    <label class="form-check-label" for="defaultCheck1">
                      {{category.value}}
                    </label>
                </div>
                
            </div>
        </div>
    </div>

    <button *ngIf="closable" (click)="close()" aria-label="Close" class="dialog__close-btn">&#10006;</button>
  </div>
  <!-- <div *ngIf="visible" class="overlay" (click)="close()"></div> -->
